(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-product"]) return;
  try {
    
if (!customElements.get('bk-product-view')) {
  customElements.define('bk-product-view', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('[data-variant-select]');
      const price = this.querySelector('[data-product-price]');
      const addButton = this.querySelector('[data-add-button]');
      const mainImage = this.querySelector('.bk-main');
      const imageLink = this.querySelector('[data-image-link]');
      const setImage = (src, alt) => {
        if (!src || !mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        if (imageLink) imageLink.href = src;
        this.querySelectorAll('[data-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.image === src)));
      };
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        setImage(option.dataset.image);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
      this.querySelectorAll('button[data-image]').forEach(button => button.addEventListener('click', () => setImage(button.dataset.image, button.dataset.alt)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
